<template>
<svg data-svg-lvl-3="edge-top-slice" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514 430"><defs></defs><g id="Крышка_Срез"><path :style="{ fill: params.sliceColor }"  class="tsl-c-3" d="M45.49,247.09H468a1.24,1.24,0,0,0,1.23-1.23v-3.4a1.24,1.24,0,0,0-1.23-1.24H45.49a1.25,1.25,0,0,0-1.24,1.24v3.39A1.25,1.25,0,0,0,45.49,247.09Z"/><path class="tsl-c-3" d="M45.49,200.78H468a1.24,1.24,0,0,0,1.23-1.24v-3.39a1.25,1.25,0,0,0-1.24-1.24H45.49a1.25,1.25,0,0,0-1.24,1.24v3.39A1.25,1.25,0,0,0,45.49,200.78Z"/></g></svg></template>


<script>
/** Этот компонент генерируется автоматически, руками ничего менять нельзя!!! */
  
export default {props: { params: { type: Object, required: true, }, }, data() { return {} },}
</script>

<style scoped>.tsl-c-1{opacity:0.3;}.tsl-c-2{fill:#64ff00;}.tsl-c-3{fill:gray;stroke:#232728;stroke-miterlimit:2;stroke-width:1.14px;}</style>

